<template>
  <tr>
    <!-- title -->

    <td>
      <router-link :to="'/posts/' + post.slug" class="color-default">{{
        post.title
      }}</router-link>
    </td>

    <!-- category -->
    <!-- {{}} -->

    <td v-if="!$route.params.category">
      <router-link
        class="color-default"
        v-if="post.category"
        :to="`/categories/${post.category.slug}/posts`"
      >
        {{ post.category.title }}
      </router-link>

      <router-link
        class="color-default"
        v-else-if="post.equipmateCategory"
        :to="`/categories/${post.equipmateCategory.slug}/posts`"
      >
        {{ post.equipmateCategory.title }}
      </router-link>
      <router-link
        class="color-default"
        v-else-if="post.lineniqcategory"
        :to="`/categories/${post.lineniqcategory.slug}/posts`"
      >
        {{ post.lineniqcategory.title }}
      </router-link>
    </td>

    <!-- <td>{{ post.views }}</td> -->

    <!-- <td>{{ post.total_recommendations }}</td> -->

    <td v-if="post.published == 1">
      <span class="text-success font-weight-bold">Yes</span>
    </td>
    <td v-else>
      <span class="text-danger font-weight-bold">No</span>
    </td>

    <!-- featured -->
    <td v-if="post.featured == 1">
      <span class="text-success font-weight-bold">Yes</span>
    </td>
    <td v-else>
      <span class="text-danger font-weight-bold">No</span>
    </td>

    <!-- comments -->
    <td>{{ post.total_comments }}</td>

    <!-- controls [Update, Delete] -->
    <td>
      <div class="btn-group">
        <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
          <span class="fas fa-ellipsis-v"></span>
        </a>
        <ul class="dropdown-menu">
          <router-link :to="'/posts/' + post.slug" class="dropdown-item"
            >View</router-link
          >
          <router-link
            class="dropdown-item"
            :to="'/posts/update-post/' + this.post.slug"
          >
            Update
          </router-link>
          <template>
            <a
              class="dropdown-item"
              v-if="post.published == 0"
              @click="publishing('publish')"
              >Publish</a
            >
            <a class="dropdown-item" v-else @click="publishing('unpublish')"
              >Unpublish</a
            >
          </template>
          <a class="dropdown-item" @click="deletePost"
            ><span class="text-danger">Delete</span></a
          >
        </ul>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  data: function () {
    return {
      post_row_loader: true,
    };
  },
  props: ["post"],

  computed: {
    author: function () {
      if (typeof this.post.author === "undefined") {
        return "unknown";
      }
      return this.post.author.name;
    },
  },
  methods: {
    publishing(action) {
      this.post_row_loader = true;
      this.$emit("skLoader", this.post_row_loader);
      this.$forceUpdate();
      this.$store
        .dispatch("posts/publishing", {
          post: this.post,
          action: action,
        })
        .then((response) => {
          // loader.hide();
          this.post_row_loader = false;
          this.$emit("skLoader", this.post_row_loader);
          this.$toast.success(response.data.message);
        });
    },

    deletePost() {
      this.$store.dispatch("message/update", {
        title: this.post.title,
        body: "Are you sure you want to delete this Post?",
        class: "danger",
        confirm: true,
      });
      this.$bus.$off("proceed");
      this.$bus.$once("proceed", () => {
        this.delete(this.post);
        this.$store.dispatch("message/close");
      });
    },

    delete(post) {
      this.$store
        .dispatch("posts/deletePost", post)
        .then((message) => {
          // send successful message
          this.$toast.success(message);
        })
        .catch((error) => {
          // send error message
          this.$toast.error(error.response.data.message);
        });
    },
  },
};
</script>
<style>
.dropdown-toggle::before,
.dropdown-toggle::after {
  border: none;
  content: none;
}

.dropdown-toggle:hover {
  background-color: #48a6a6;
  color: white;
}

.dropdown-toggle {
  border-radius: 50%;
}

.dropdown-item {
  cursor: pointer;
}
</style>

<style scoped>
table tr td:nth-child(1) {
  width: 30% !important;
  content: "hihihi";
}

table tr td:nth-child(2) {
  width: 20% !important;
}

table tr td:nth-child(3) {
  width: 15% !important;
}

table tr td:nth-child(4) {
  width: 15% !important;
}

table tr td:nth-child(5) {
  width: 10% !important;
}

table tr td:nth-child(6) {
  width: 10% !important;
}

.table tr td:not(:nth-child(5)):not(:nth-child(6)) {
  text-align: left !important;
}

.table tr td:nth-child(5):nth-child(6) {
  text-align: center !important;
}
</style>
